export const SURVEY_QUESTION_TYPES = Object.freeze({
  NUMERIC_SCALE: 'numeric_scale',
  STAR_RATING: 'star_rating',
  SINGLE_CHOICE: 'single_choice',
  MULTIPLE_CHOICE: 'multiple_choice',
  SHORT_TEXT: 'short_text',
  LONG_TEXT: 'long_text',
})

export const SURVEY_CHOICE_TYPES = Object.freeze([
  SURVEY_QUESTION_TYPES.SINGLE_CHOICE,
  SURVEY_QUESTION_TYPES.MULTIPLE_CHOICE,
])

export const SURVEY_TEXT_TYPES = Object.freeze([
  SURVEY_QUESTION_TYPES.SHORT_TEXT,
  SURVEY_QUESTION_TYPES.LONG_TEXT,
])

export const SURVEY_ERROR_CODES = Object.freeze({
  ALREADY_SUBMITTED: 'SURVEY_ALREADY_SUBMITTED',
  REQUIRED_BEFORE_QUIZ: 'SURVEY_REQUIRED_BEFORE_QUIZ',
})
